<onyx-modal
  variant="center"
  [heading]="
    fleet.trailer || fleet.vehicle ? `${I18N}.editSet` : `${I18N}.newSet`
  "
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <div class="container">
    @if (fleet.trailer) {
      <onyx-tabs
        [label]="`${I18N}.whatToDo`"
        [tabs]="TABS"
        [(value)]="mode"
        [showRequired]="false"
        [fill]="true"
        [size]="40"
        width="100%"
      ></onyx-tabs>
    }
    @let isChangeMode = mode() === FleetSetsModalSection.CHANGE;
    @if (isChangeMode) {
      <form class="switch" [formGroup]="changeForm" [onyxAutoFocus]="true">
        @let controls = changeForm.controls;
        <onyx-dropdown
          data-testid="vehicle-dropdown"
          [formControl]="controls.vehicle"
          label="labels.vehicle"
          [link]="links().vehicle"
          [options]="VEHICLES_SOURCE"
          [optional]="true"
          (selectedOptionValueChange)="vehicle.set($event.value)"
        ></onyx-dropdown>

        <onyx-dropdown
          data-testid="trailer-dropdown"
          [formControl]="controls.trailer"
          [label]="trailerLabel()"
          [link]="links().trailer"
          [options]="TRAILERS_SOURCE"
          [optional]="true"
          (selectedOptionValueChange)="trailer.set($event.value)"
        ></onyx-dropdown>
      </form>

      @if (warningMessage(); as message) {
        <onyx-message intent="warning">
          <onyx-icon
            name="alert-circle-two-tone-filled"
            [size]="20"
          ></onyx-icon>

          <p [innerHTML]="`${I18N}.${message.type}` | translate: message"></p>
        </onyx-message>
      }
    } @else {
      <form class="swap" [formGroup]="swapForm">
        @let first = firstSet(); @let second = secondSet();
        <div class="item">
          @let controls = swapForm.controls;
          <onyx-dropdown
            data-testid="first-set-dropdown"
            [formControl]="controls.firstSet"
            [label]="`${I18N}.firstSet`"
            [options]="SETS_SOURCE"
            (selectedOptionValueChange)="firstSet.set($event.value)"
          ></onyx-dropdown>

          @if (first && second) {
            <onyx-icon name="arrow-right-outlined" [size]="20"></onyx-icon>

            <onyx-text-field
              [label]="`${I18N}.firstSet`"
              [disabled]="true"
              [value]="`${(first | fleetIdentifier: 'bracket')} · ${(second.trailer | fleetIdentifier: 'bracket')}`"
            ></onyx-text-field>
          }
        </div>

        <div class="item">
          <onyx-dropdown
            data-testid="second-set-dropdown"
            [formControl]="controls.secondSet"
            [label]="`${I18N}.secondSet`"
            [options]="SETS_SOURCE"
            [optional]="true"
            (selectedOptionValueChange)="secondSet.set($event.value)"
          ></onyx-dropdown>

          @if (second && first) {
            <onyx-icon name="arrow-right-outlined" [size]="20"></onyx-icon>

            <onyx-text-field
              [label]="`${I18N}.secondSet`"
              [disabled]="true"
              [value]="`${(second | fleetIdentifier: 'bracket')} · ${(first.trailer | fleetIdentifier: 'bracket')}`"
            ></onyx-text-field>
          }
        </div>
      </form>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button
      data-testid="cancel-button"
      variant="outlined"
      (click)="close$.next()"
    >
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      data-testid="save-button"
      [spinner]="loading()"
      [disabled]="isChangeMode ? !changeFormChanged() : false"
      (click)="
        !loading()
          ? isChangeMode
            ? submitChangeForm()
            : submitSwapForm()
          : null
      "
    >
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
